import { render, staticRenderFns } from "./LoadingLinear.vue?vue&type=template&id=efb5d4fc&scoped=true&"
var script = {}
import style0 from "./LoadingLinear.vue?vue&type=style&index=0&id=efb5d4fc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb5d4fc",
  null
  
)

export default component.exports